(() => {
  if (window.PeakStyleDefaultCrossSellInstalled) return;
  window.PeakStyleDefaultCrossSellInstalled = true;

  const install = () => {
    const template = document.getElementById('PeakStyleDefaultCrossSell');
    if (!template) return;
    const block = document.querySelector('.template-product .product-recommendations');
    if (!block) return;
    const current = block.querySelector('[data-products-container]');
    if (!current) return;

    const replacement = current.cloneNode(false);
    replacement.removeAttribute('data-is-flickity-enabled');
    replacement.removeAttribute('data-flickity-enabled');
    replacement.innerHTML = '';
    replacement.appendChild(template.content.cloneNode(true));
    current.replaceWith(replacement);

    block.dataset.crossSellEngine = 'default-activity-audience-sibling-category';
    block.dataset.crossSellRule = 'global-default';
    delete block.dataset.peakstyleCrossSellReady;

    window.setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('peakstyle:cross-sell-default-installed'));
    }, 0);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();
